export enum EFeedbackDeactivationType {
  WIDGET_DEACTIVATED = 'widget-deactivated',
  PROVIDER_DISCONNECTED = 'provider-disconnected'
}

export type TFeedbackDeactivationType =
  | EFeedbackDeactivationType.PROVIDER_DISCONNECTED
  | EFeedbackDeactivationType.WIDGET_DEACTIVATED;

export type TFeedbackSend = {
  rating: number;
  comment?: string;
  provider?: string;
};

export type TFeedbackDeactivationSend = {
  rating: number;
  comment?: string;
  reasons: String[];
  provider?: string;
};

export type TFeedbackEmailSend = {
  rating: number;
  comment?: string;
  businessId: string;
  customerId: string;
  provider?: string;
};
